import axios from "axios";

export default {
  fetchAll: async () => {
    const response = await axios.get('/api/admin/tests/');
    return response.data;
  },
  getTest: async id => {
    const response = await axios.get('/api/tests/' + id);
    return response.data;
  },
  getTestFull: async id => {
    const response = await axios.get('/api/admin/tests/' + id);
    return response.data;
  },
  createTest: async form => {
    const { data } = await form.post('/api/admin/tests/create');
    return data;
  },
  updateTest: async form => {
    const { data } = await form.patch('/api/admin/tests/' + form.id);
    return data;
  },
  removeTest: async id => {
    const response = await axios.delete('/api/admin/tests/' + id);
    return response.data;
  }
};
